import React from "react";
import { useMsal } from "@azure/msal-react";
import Button from "react-bootstrap/Button";
import { msalConfig } from './authConfig';
import { saveMsToken } from "../../helper/studentMetadata";

/**
 * Renders a sign-out button
 */
export const SignOutButton = ({ performSignOut, variant }) => {
    const { instance } = useMsal();

    const handleLogout = () => {
        saveMsToken(null);
        const logoutType = msalConfig().auth.logoutType;

        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    if (performSignOut) {
        handleLogout();
        return null;
    }

    variant = variant ? variant : "primary";

    return (
        <Button variant={variant} onClick={() => handleLogout()} >Cerrar Sesión</Button>
    )
};

export const PerformSignOut = () => {
    useSignOut();
};

const useSignOut = () => {
    const { instance } = useMsal();
    const logoutType = msalConfig.auth.logoutType;

    saveMsToken(null);

    if (logoutType === "popup") {
        instance.logoutPopup({
            postLogoutRedirectUri: "/",
            mainWindowRedirectUri: "/"
        });
    } else if (logoutType === "redirect") {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }

    return null;
}

